import { setClassName } from '@change-corgi/core/error';
import type { GQLResponsePerimeterXChallengeError } from '@change-corgi/core/gqlErrors';

/**
 * Thrown when the retry after a solved captcha is challenged again, so callers can tell it apart
 * from an unsolved captcha (which rethrows the original GQLResponsePerimeterXChallengeError).
 * The retry's challenge is kept as `cause`.
 */
export class PerimeterXRechallengeError extends Error {
	constructor(cause: GQLResponsePerimeterXChallengeError) {
		super('PerimeterX challenged the retry after a solved captcha', { cause });
	}
}
setClassName(PerimeterXRechallengeError, 'PerimeterXRechallengeError');
